import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { fTimeDate } from '@/actions/Helper';
import styles from './styles';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import CustomMultiSelect from '../../ctComponents/CustomMultiSelect/CustomMultiSelect';
import PageContainerTabs from '@/components/PageContainerTabs';
import LoadingV2 from '@/components/Loading';

export default ({
  DATA = [],
  DATAOrders = [],
  DATARequests = [],
  chatTypeParams,
  ordersSeen,
  requestsSeen,
  getInventoryList,
}) => {
  const cls = styles();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('offer');
  const [ordersList, setOrdersList] = useState(DATAOrders);
  const [requestsList, setRequestsList] = useState(DATARequests);
  const [tableData, setTableData] = useState([]);
  const [display, setDisplay] = useState('none');
  const [filteroption, setFilteroption] = useState([]);
  const [loadingMatch, setLoadingMatch] = useState(false);
  const [isInitialMount, setIsInitialMount] = useState(true);
  const filterButtonRef = useRef(null);

  const mainScroll = document.getElementsByTagName('main')[0];

  const user_id = useSelector((state) => state?.reducer.user.id);
  const filterOpt = [
    { label: 'Reserved', value: 1, color: '#717784' },
    { label: 'Approved', value: 4, color: '#178C4E' },
    { label: 'Pre-Approved', value: 3, color: '#335CFF' },
    { label: 'Disputed', value: 6, color: '#D02533' },
    // { label: 'Canceled', value: 0, color: '#E97135' },
    { label: 'Rejected', value: 0, color: '#E97135' },
  ];
  useEffect(() => {
    if (chatTypeParams === 'offer') {
      setActiveTab('offer');
    } else if (chatTypeParams === 'request') {
      setActiveTab('request');
    }
  }, [DATA, chatTypeParams]);

  useEffect(() => {
    setOrdersList(DATAOrders);
    setRequestsList(DATARequests);
  }, [DATAOrders, DATARequests]);

  const getActiveContainers = React.useCallback(
    (inventory) => {
      if (inventory) {
        let activeContainers = [];
        let deactiveContainers = [];
        inventory.containers.forEach((container) => {
          if (container.status === 1) {
            activeContainers.push(container);
          } else if (container.status === 0) {
            deactiveContainers.push(container);
          }
        });

        if (deactiveContainers.length === 0) {
          return (
            <input
              type="checkbox"
              className={`all ${cls.containerChecBox}`}
              checked={true}
            />
          );
        } else if (activeContainers.length === 0) {
          return (
            <input
              type="checkbox"
              className={`any ${cls.containerChecBox}`}
              checked={false}
            />
          );
        } else {
          return (
            <input
              type="checkbox"
              checked={true}
              className={`some ${cls.containerChecBox}`}
            />
          );
        }
      }
    },
    [cls.containerChecBox]
  );

  useEffect(() => {
    let someCompletedCheckboxs = document.getElementsByClassName('some');
    let allCompletedCheckboxs = document.getElementsByClassName('all');
    let notCompletedCheckboxs = document.getElementsByClassName('any');
    for (let i = 0; i < someCompletedCheckboxs.length; i++) {
      someCompletedCheckboxs[i].indeterminate = true;
    }
    for (let i = 0; i < allCompletedCheckboxs.length; i++) {
      allCompletedCheckboxs[i].indeterminate = false;
    }
    for (let i = 0; i < notCompletedCheckboxs.length; i++) {
      notCompletedCheckboxs[i].indeterminate = false;
      notCompletedCheckboxs[i].checked = false;
    }
  }, [getActiveContainers, getInventoryList]);

  const amirbiosRef = useRef(null);
  const tableRef = useRef(null);
  const amirbios1Ref = useRef(null);
  const amirbios2Ref = useRef(null);
  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (amirbiosRef.current && amirbios1Ref.current) {
        const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;

        if (amirbiosTop <= -10) {
          amirbios2Ref.current.classList.add(cls.fixHeaderInbox);
          tableRef.current.classList.add(cls.tableTopMarginInbox);
        } else {
          amirbios2Ref.current.classList.remove(cls.fixHeaderInbox);
          tableRef.current.classList.remove(cls.tableTopMarginInbox);
        }
      }
      syncScroll('amirbios');
    };
    const updateWidth = () => {
      if (tableRef.current && amirbios1Ref.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        const tableeCurrentWidth =
          amirbiosRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (amirbiosRef.current || amirbios2Ref.current) {
        if (source === 'amirbios') {
          amirbios2Ref.current.scrollLeft = amirbiosRef.current.scrollLeft;
        } else if (source === 'amirbios2') {
          amirbiosRef.current.scrollLeft = amirbios2Ref.current.scrollLeft;
        }
      }
    };

    updateWidth();
    updateHeadWidth();

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    const handleScroll1 = () => syncScroll('amirbios');
    const handleScroll2 = () => syncScroll('amirbios2');

    if (amirbiosRef.current) {
      amirbiosRef.current.addEventListener('scroll', handleScroll1);
    }

    if (amirbios1Ref.current) {
      amirbios2Ref.current.addEventListener('scroll', handleScroll2);
    }

    mainScroll.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateWidth);
    window.addEventListener('resize', updateHeadWidth);
    mainScroll.addEventListener('scroll', updateWidth);
    mainScroll.addEventListener('scroll', updateHeadWidth);

    return () => {
      mainScroll.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateWidth);
      mainScroll.removeEventListener('resize', updateHeadWidth);
      mainScroll.removeEventListener('scroll', updateWidth);
      mainScroll.removeEventListener('scroll', updateHeadWidth);

      if (amirbiosRef.current) {
        amirbiosRef.current.removeEventListener('scroll', handleScroll1);
      }

      if (amirbios2Ref.current) {
        amirbios2Ref.current.removeEventListener('scroll', handleScroll2);
      }
    };
  }, [
    tableData,
    cls.fixHeaderInbox,
    cls.tableTopMarginInbox,
    tableWidth,
    mainScroll,
  ]);

  useEffect(() => {
    if (amirbios2Ref.current) {
      amirbios2Ref.current.style.width = `${spanWidth}px`;
    }
  }, [spanWidth]);

  useEffect(() => {
    if (amirbios1Ref.current) {
      amirbios1Ref.current.style.width = `${tableWidth - 4}px`;
    }
  }, [tableWidth]);

  useEffect(() => {
    if (activeTab === 'request') {
      // Only show loading if it's not the initial mount
      if (!isInitialMount) {
        setLoadingMatch(true);
      }
      setTimeout(() => {
        setLoadingMatch(false);

        filteroption.length > 0
          ? setTableData(
              requestsList.filter((request) =>
                filteroption
                  .map((option) => option.value)
                  .includes(request.staus)
              )
            )
          : setTableData(requestsList);
      }, 800);
    } else if (activeTab === 'offer') {
      // Only show loading if it's not the initial mount
      if (!isInitialMount) {
        setLoadingMatch(true);
      }
      setTimeout(() => {
        setLoadingMatch(false);

        filteroption.length > 0
          ? setTableData(
              ordersList.filter((order) =>
                filteroption.map((option) => option.value).includes(order.staus)
              )
            )
          : setTableData(ordersList);
      }, 800);
    }
  }, [activeTab, requestsList, ordersList, filteroption, isInitialMount]);

  const checkImage = (message) => {
    if (
      message?.startsWith('blob:') ||
      message?.includes('https://smart-turn.com/storage/message') ||
      message?.includes('https://apitest.smart-turn.com/storage/message') ||
      message?.includes('https://testapi.smart-turn.com/storage/message') ||
      message?.includes('https://api.smart-turn.com/storage/message')
    ) {
      return (
        <span>
          <img height="25px" src={message} alt="image" />
        </span>
      );
    } else {
      return message;
    }
  };

  const FilterPress = () => {
    setDisplay(display === 'none' ? true : 'none');
  };

  return (
    <div ref={amirbiosRef} id="amirbios" className={cls.listContainer}>
      {loadingMatch === true && <LoadingV2 isFullscreen />}
      <div className={cls.tabLinksDiv}>
        <PageContainerTabs
          titlesLinks={[
            {
              title: 'Requests',
              pushAddress: 'request',
              badge: requestsSeen || 0,
            },
            {
              title: 'Offers',
              pushAddress: 'offer',
              badge: ordersSeen || 0,
            },
          ]}
          baseAddress="/inbox/"
          activeTab={activeTab}
          setActiveTab={(step) => {
            setActiveTab(step);
            setIsInitialMount(false);
          }}
        />

        <div
          ref={filterButtonRef}
          className={
            display === 'none' ? cls.selectContainer : cls.selectContainerActive
          }
          onClick={FilterPress}>
          <ReactSVG src={Icons.filterNew} />
          {filteroption.length > 0 ? (
            <div className={cls.selectContainerLable}>
              <span>{filteroption.length} item selected</span>
            </div>
          ) : (
            <div
              className={cls.selectContainerLable}
              style={{ marginRight: '20px' }}>
              <span>Status Filter</span>
            </div>
          )}
          <ReactSVG src={Icons.arrowDown} className={cls.arrowDownSelect} />
          <CustomMultiSelect
            display={display}
            setDisplay={setDisplay}
            options={filterOpt}
            setFilter={setFilteroption}
            selectedFilters={filteroption}
            filterButtonRef={filterButtonRef}
          />
        </div>
      </div>
      {filteroption.length > 0 && (
        <div className={cls.optionsShow}>
          <p>Filtered by:</p>
          {filteroption.map((option) => {
            return (
              <div
                key={option.value}
                className={cls.optionContainer}
                style={{
                  borderColor: option.color,
                  color: option.color,
                }}>
                <span>{option.label}</span>
                <ReactSVG
                  src={Icons.closeIcon}
                  className={cls.closeP}
                  beforeInjection={(svg) => {
                    svg.querySelectorAll('path').forEach((path) => {
                      path.setAttribute('stroke', option.color);
                    });
                  }}
                  onClick={() =>
                    setFilteroption((prev) =>
                      prev.filter((opt) => opt !== option)
                    )
                  }
                />
              </div>
            );
          })}
        </div>
      )}
      {tableData.length === 0 ? (
        <table ref={tableRef} id="table" className={cls.list}>
          <thead ref={amirbios2Ref} id="amirbios1">
            <tr ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
              <th style={{ flex: 0.7 }}>Name</th>
              <th style={{ flex: 0.5 }}>Date</th>
              <th style={{ flex: 0.5 }}>Size</th>
              <th style={{ flex: 0.5 }}>SSL</th>
              <th style={{ flex: 0.5 }}>City</th>
              <th style={{ flex: 0.4 }}>Number</th>
              <th style={{ flex: 0.4 }}>Chassis</th>
              <th style={{ flex: 0.4 }}>Flip Service</th>
              <th style={{ flex: 2 }}>Messages</th>
              <th style={{ flex: 0.6 }}>Status</th>
            </tr>
          </thead>
          <tbody className={cls.tableBody}>
            <span className={cls.emptyTableHandler}>
              <ReactSVG
                src={Icons.emptyHandle}
                className={cls.emptyTableIcon}
              />
              There are no orders.
            </span>
          </tbody>
        </table>
      ) : tableData.length > 0 ? (
        <table ref={tableRef} id="table" className={cls.list}>
          <thead ref={amirbios2Ref} id="amirbios1">
            <tr ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
              <th style={{ flex: 0.7 }}>Name</th>
              <th style={{ flex: 0.5 }}>Date</th>
              <th style={{ flex: 0.5 }}>Size</th>
              <th style={{ flex: 0.5 }}>SSL</th>
              <th style={{ flex: 0.5 }}>City</th>
              <th style={{ flex: 0.4 }}>Number</th>
              <th style={{ flex: 0.4 }}>Chassis</th>
              <th style={{ flex: 0.4 }}>Flip Service</th>
              <th style={{ flex: 2 }}>Messages</th>
              <th style={{ flex: 0.6 }}>Status</th>
            </tr>
          </thead>
          <tbody className={cls.tableBody}>
            {tableData?.map((item, idx) => (
              <tr
                key={idx}
                onClick={() =>
                  history.push(`/inbox/chat/${item.id}-${item.mode}-${user_id}`)
                }
                className={
                  item.last_message_object?.is_seen === 0 &&
                  user_id !== item.last_message_object.user_id
                    ? cls.tableRowUnSeen
                    : cls.tableRow
                }>
                <td style={{ flex: 0.71 }}>
                  {item.inventory?.user?.company
                    ? item.inventory?.user?.company
                    : item?.user?.company
                    ? item?.user?.company
                    : 'Unknown'}
                </td>
                <td style={{ flex: 0.5 }}>{fTimeDate(item.updated_at)}</td>
                {/* <td style={{ flex: 0.6 }}>{item.mode}</td> */}
                <td style={{ flex: 0.5 }}>
                  {item.reserved_request_data?.size}
                </td>
                <td style={{ flex: 0.5 }}>
                  {activeTab === 'request'
                    ? item.inventory?.cabin?.company?.name
                    : item.inventory_with_out_user?.cabin?.company.name}
                </td>
                <td style={{ flex: 0.5 }}>
                  {item?.reserved_request_data?.city}
                </td>
                <td style={{ flex: 0.4 }}>
                  {item.count_to_show > 0
                    ? item.count_to_show
                    : item.requested_count}
                </td>
                <td style={{ flex: 0.4 }}>
                  {item.chase_type === 'normal' ? 'Own/Pool' : item.chase_type}
                </td>
                <td style={{ flex: 0.4 }}>
                  {item.reserved_request_data?.flip_service === 1
                    ? 'Yes'
                    : 'No'}
                </td>
                {item.last_message_object?.is_seen === 0 &&
                user_id !== item.last_message_object.user_id ? (
                  <Tooltip
                    arrow
                    title={item?.last_message}
                    placement="top-start">
                    <td className={cls.MsgNuSeenTd} style={{ flex: 2 }}>
                      <span className={cls.lastMsgNuSeenTd}>
                        <span className={cls.dotSpan}>● </span>
                        {checkImage(item?.last_message)}
                      </span>
                    </td>
                  </Tooltip>
                ) : (
                  <Tooltip
                    arrow
                    title={item?.last_message}
                    placement="top-start">
                    <td className={cls.MsgNuSeenTd} style={{ flex: 2 }}>
                      <span className={cls.lastMsgTd}>
                        {checkImage(item?.last_message)}
                      </span>
                    </td>
                  </Tooltip>
                )}
                <td style={{ flex: 0.6 }}>
                  <span
                    className={
                      item.status_string === 'Pre-Approved'
                        ? cls.statusSpanPreApproved
                        : item.status_string === 'Approved'
                        ? cls.statusSpanApproved
                        : item.status_string === 'Rejected'
                        ? cls.statusSpanRejected
                        : item.status_string === 'Disputed'
                        ? cls.statusSpanDisputed
                        : item.status_string === 'Reserved'
                        ? cls.statusSpanReserved
                        : cls.statusSpan
                    }>
                    {item.status_string}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        ''
      )}
    </div>
  );
};
